import { z } from 'zod';
/** Lifecycle of a session row. Deletion is soft, so the row outlives the conversation. */
export const AgentSessionStateSchema = z.enum(['Active', 'SoftDeleted']);
export const DeleteAgentSessionResponseSchema = z.object({ id: z.uuidv7() });
//# sourceMappingURL=state.js.map